// extracted by mini-css-extract-plugin
export var fadeIn = "_lf-1";
export var modalContent = "_lf-3";
export var overlay = "_lf-0";
export var popoverContent = "_lf-2";
export var results = "_lf-5";
export var searchInputWrapper = "_lf-4";